export const RECOMMENDED_FOR_YOU = 'recommendedForYou';
export const OTHER_GIGS_BY = 'otherGigsBy';
export const RECOMMENDED_IN_SUBCATEGORY = 'recommendedInSubCategory';
export const RECENTLY_VIEWED = 'recentlyViewed';

export const CAROUSEL_CONTEXT = 'recommendation';
